const Bio = () => {

    return (
        <div className="main">
            <div className={"bio"}>
                <p>
                    Hi, I am DJ Dave! I have been in the entertainment business for over 30 years. I graduated college
                    with a degree in creative arts and technology. My passion is music, entertainment, and people. Currently
                    I am a full-time corporate event Emcee, DJ, and Karaoke Jockey.  I am the official DJ for the sales division
                    of Mondelez International Inc. I specialize in elderly care by handling
                    karaoke and various events throughout many adult living facilities in the valley.
                </p>
                <p>
                    Please click the links above to schedule me to Emcee your party, DJ your event, or book Karaoke for your venue.
                    You can also contact me, view my social media, and view my pictures and videos. Check the schedule link to see my
                    current live schedule if you would like to come sing karaoke.
                </p>
            </div>


        </div>
    )

}; export default Bio;